import { Alignment, ColumnComposition, ColumnCompositions } from '@blk/simba';
import { CellData } from '@ddt-web/data-service';

import { CmaTableConfigEntries } from '../../iretire/config';
import { TableCompositionHelper } from './table-composition-helper';

export class CmaTableColumnComposition {
	protected textSize: string = 'text-8';
	protected boxModel = { paddingLeft: 5, paddingRight: 5 };

	protected getHeaderRowCompositions(headers: Array<CellData>, columnProportions: Array<number>): Array<ColumnComposition> {
		return headers.map((header: CellData, index: number) =>
			TableCompositionHelper.getColumnComposition(
				header,
				columnProportions[index],
				['text-bold', this.textSize],
				Alignment.Horizontal.Left,
				Alignment.Vertical.Bottom,
				this.boxModel
			)
		);
	}

	public getColumnCompositions(tableData: CmaTableConfigEntries[], headers: Array<string>, tableColumnProportions: Array<number>): ColumnCompositions {
		const tableHeaders: Array<CellData> = headers.map(item => new CellData({} as any, item, item));
		const columnProportions: Array<number> = tableColumnProportions;
		const formattedTableData = tableData.map(item => {
			const row: CellData[] = [];
			for (const key in item) {
				if (item[key]) {
					row.push(new CellData({} as any, item[key], item[key]));
				}
			}
			return row;
		});

		return new ColumnCompositions(
			this.getHeaderRowCompositions(tableHeaders, columnProportions),
			formattedTableData.map((row: Array<CellData>) => {
				return [
					...row.map((cell: CellData, cellIndex: number) =>
						TableCompositionHelper.getColumnComposition(
							cell,
							columnProportions[cellIndex],
							[this.textSize, 'text-condensed-light'],
							cellIndex === 0 ? Alignment.Horizontal.Left : Alignment.Horizontal.Center,
							Alignment.Vertical.Middle,
							this.boxModel
						)
					)
				];
			})
		);
	}
}
